module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus",
      "size": "mini"
    },
    on: {
      "click": _vm.addItems
    }
  }, [_vm._v("添加商品")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "商品名称",
      "size": "mini"
    },
    model: {
      value: (_vm.goodsName),
      callback: function($$v) {
        _vm.goodsName = $$v
      },
      expression: "goodsName"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.goodsSearch
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.ItemsList,
      "height": _vm.wheight - 220
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "itemId",
      "label": "商品ID",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "排序编号",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "placeholder": ""
          },
          on: {
            "change": function($event) {
              return _vm.editItemsSort(scope.$index, scope.row)
            }
          },
          model: {
            value: (scope.row.sort),
            callback: function($$v) {
              _vm.$set(scope.row, "sort", $$v)
            },
            expression: "scope.row.sort"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "itemName",
      "label": "商品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "prop": "price",
      "label": "价格",
      "formatter": _vm.priceformatter
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "label": "核销类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.consumeType == 'all') ? _c('span', [_vm._v("团购券类型")]) : (scope.row.consumeType == 'every') ? _c('span', [_vm._v("次卡类型")]) : _c('span', [_vm._v("充值记录")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "operating-icons"
        }, [_c('i', {
          staticClass: "iconfont icon-search-plus",
          on: {
            "click": function($event) {
              return _vm.itemsDetail(scope.$index, scope.row)
            }
          }
        }), _vm._v(" "), _c('i', {
          staticClass: "iconfont icon-edit1",
          on: {
            "click": function($event) {
              return _vm.editItemsAction(scope.$index, scope.row)
            }
          }
        }), _vm._v(" "), _c('i', {
          staticClass: "mark iconfont icon-trash-alt1",
          on: {
            "click": function($event) {
              return _vm.deleteItemsAction(scope.$index, scope.row)
            }
          }
        })])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.params.page,
      "page-sizes": [10, 20, 50],
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    staticClass: "good-detail-dialog",
    attrs: {
      "title": "商品详情",
      "visible": _vm.ItemsDetailVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.ItemsDetailVisible = $event
      }
    }
  }, [
    [_c('el-row', {
      staticClass: "row-bg"
    }, [_c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v("核销类型")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 21
      }
    }, [(_vm.itemsDetailData.consume_type == 'every') ? _c('div', {
      staticClass: "grid-content"
    }, [_vm._v("次卡类型")]) : _vm._e(), _vm._v(" "), (_vm.itemsDetailData.consume_type == 'all') ? _c('div', {
      staticClass: "grid-content"
    }, [_vm._v("团购券类型")]) : _vm._e()])], 1), _vm._v(" "), _c('el-row', {
      staticClass: "row-bg"
    }, [_c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v("商品名称")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 21
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v(_vm._s(_vm.itemsDetailData.item_name))])])], 1), _vm._v(" "), _c('el-row', {
      staticClass: "row-bg"
    }, [_c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v("简述")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 21
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v(_vm._s(_vm.itemsDetailData.brief))])])], 1), _vm._v(" "), _c('el-row', {
      staticClass: "row-bg"
    }, [_c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v("价格")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 21
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v("￥" + _vm._s(_vm.itemsDetailData.price / 100) + " ")])])], 1), _vm._v(" "), _c('el-row', {
      staticClass: "row-bg"
    }, [_c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v("原价")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 21
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v("￥" + _vm._s(_vm.itemsDetailData.market_price / 100) + " ")])])], 1), _vm._v(" "), _c('el-row', {
      staticClass: "row-bg"
    }, [_c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v("图片")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 21
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_c('div', {
      staticClass: "block"
    }, [_c('el-carousel', {
      attrs: {
        "height": "200px",
        "width": "375px",
        "autoplay": true,
        "indicator-position": "outside"
      }
    }, [(_vm.itemsDetailData.pics) ? _vm._l((_vm.itemsDetailData.pics), function(pic) {
      return _c('el-carousel-item', {
        key: pic,
        style: ({
          backgroundImage: 'url(' + _vm.wximageurl + pic + ')',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        })
      })
    }) : _vm._e()], 2)], 1)])])], 1), _vm._v(" "), _c('el-row', {
      staticClass: "row-bg"
    }, [_c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v("基础物料")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 21
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.itemsDetailData.consume_type == 'all'),
        expression: "itemsDetailData.consume_type=='all'"
      }],
      staticClass: "grid-content grid-attribute"
    }, [_c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.itemsDetailData.type_labels
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "labelName",
        "label": "物料名称"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "单价(元)"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('span', [_vm._v("￥" + _vm._s(scope.row.labelPrice / 100))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "num",
        "label": "数量"
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.itemsDetailData.consume_type == 'every'),
        expression: "itemsDetailData.consume_type=='every'"
      }],
      staticClass: "grid-content grid-attribute"
    }, [_c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.itemsDetailData.type_labels
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "labelName",
        "label": "物料名称"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "单价(元)"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('span', [_vm._v("￥" + _vm._s(scope.row.labelPrice / 100))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "limitTime",
        "label": "有效期"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "num",
        "label": "数量"
      }
    })], 1)], 1)])], 1), _vm._v(" "), _c('el-row', {
      staticClass: "row-bg"
    }, [_c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v("有效期")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 21
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.itemsDetailData.date_type == 'DATE_TYPE_FIX_TIME_RANGE'),
        expression: "itemsDetailData.date_type=='DATE_TYPE_FIX_TIME_RANGE'"
      }],
      staticClass: "grid-content grid-detail"
    }, [_vm._v("\n          固定日期范围 " + _vm._s(_vm.start_date) + " ~ " + _vm._s(_vm.end_date) + "\n        ")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.itemsDetailData.date_type == 'DATE_TYPE_FIX_TERM'),
        expression: "itemsDetailData.date_type=='DATE_TYPE_FIX_TERM'"
      }],
      staticClass: "grid-content grid-detail"
    }, [_vm._v("\n          领取后 " + _vm._s(_vm.itemsDetailData.fixed_term) + " 天内有效\n        ")])])], 1), _vm._v(" "), _c('el-row', {
      staticClass: "row-bg"
    }, [_c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v("详情")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 21
      }
    }, [_c('div', {
      staticClass: "grid-content grid-detail",
      domProps: {
        "innerHTML": _vm._s(_vm.itemsDetailData.intro)
      }
    })])], 1), _vm._v(" "), (_vm.itemsDetailData.enable_agreement) ? _c('el-row', {
      staticClass: "row-bg"
    }, [_c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('div', {
      staticClass: "grid-content"
    }, [_vm._v("购买协议")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 21
      }
    }, [_c('div', {
      staticClass: "grid-content grid-detail",
      domProps: {
        "innerHTML": _vm._s(_vm.itemsDetailData.purchase_agreement)
      }
    })])], 1) : _vm._e()], _vm._v(" "), _c('div', {
      staticClass: "dialog-footer content-center",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      nativeOn: {
        "click": function($event) {
          _vm.ItemsDetailVisible = false;
          _vm.itemsDetailData = {}
        }
      }
    }, [_vm._v("取消")])], 1)
  ], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1a3fd0f8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a3fd0f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/goods/service/items/list.vue
// module id = 2509
// module chunks = 0